export const getAuxiliares = async (contadorId = null) => {
    const url = contadorId
        ? `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/dashboard/auxiliares?id_contador=${contadorId}`
        : `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/dashboard/auxiliares`;

    try {
        const resp = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'x-token': localStorage.getItem('token')
            },
        });

        const respuesta = await resp.json();

        if (resp.ok) {
            return respuesta.auxiliares;
        } else {
            console.log('Error al cargar auxiliares:', respuesta);
            return [];
        }
    } catch (error) {
        console.log('Error fetching auxiliares:', error);
        return [];
    }
};
